import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { ToastController } from '@ionic/angular';

import { SitesFavorisProvider } from '../sites-favoris/sites-favoris.provider';
import { Network } from '@capacitor/network';
import { GetSitePortefeuilleResponseDto } from '../../../api/models/get-site-portefeuille-response-dto';

export const LIMIT_MAX_FAVORI = 50;

@Injectable({ providedIn: 'root' })
export class StarredSitesService {
  isFull$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  isStarredSitesAdded$: BehaviorSubject<GetSitePortefeuilleResponseDto> =
    new BehaviorSubject<GetSitePortefeuilleResponseDto>(null);
  isStarredSitesRemoved$: BehaviorSubject<GetSitePortefeuilleResponseDto> =
    new BehaviorSubject<GetSitePortefeuilleResponseDto>(null);

  isConnected: boolean = true;

  constructor(
    private toastController: ToastController,
    private translateService: TranslateService,
    private sitesFavorisProvider: SitesFavorisProvider
  ) {
    Network.addListener('networkStatusChange', (status) => {
      this.isConnected = status.connected;
    });
    this.loadStarredSites().then((sites) => {
      this.isFull$.next(sites.size >= LIMIT_MAX_FAVORI);
    });
  }

  async loadStarredSites(): Promise<Set<string>> {
    return await this.sitesFavorisProvider.getSitesFavoris();
  }

  async isStarredSite(idSite: string): Promise<boolean> {
    let starredSites = await this.loadStarredSites();
    return starredSites.has(idSite);
  }

  async isSiteFavoriLimitReached() {
    const favoriSize = (await this.loadStarredSites()).size;
    return favoriSize === LIMIT_MAX_FAVORI;
  }

  async updateStarredSite(site: GetSitePortefeuilleResponseDto): Promise<void> {
    if (!this.isConnected) {
      let toast = await this.toastController.create({
        message: this.translateService.instant('FAVORIS.OFFLINE_FAVORIS_ERROR_MESSAGE'),
        duration: 5000,
      });
      await toast.present();
      return;
    }
    let starredSites = await this.loadStarredSites();
    if (starredSites.has(site.id_site)) {
      starredSites.delete(site.id_site);
      this.isFull$.next(false);
      this.sitesFavorisProvider.updateSitesFavoris(Array.from(starredSites));
      this.isStarredSitesRemoved$.next(site);
    } else {
      if (await this.isSiteFavoriLimitReached()) {
        return;
      }
      starredSites.add(site.id_site);
      this.sitesFavorisProvider.updateSitesFavoris(Array.from(starredSites));
      this.isStarredSitesAdded$.next(site);

      if (await this.isSiteFavoriLimitReached()) {
        this.isFull$.next(true);
        let toast = await this.toastController.create({
          message: this.translateService.instant('FAVORIS.MAX_FAVORIS_ERROR_MESSAGE'),
          duration: 5000,
        });
        await toast.present();
      }
    }
  }
}
